import {
    HttpClient,
    HttpParams
} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "src/environments/environment";
import {BaseRestService} from "./baseRestService"
import {Favourite} from '../../classes/rest-classes/Favourite';
import {Dictionary} from "../../classes/Dictionary";
import {ProductSummary} from "../../classes/rest-classes/ProductSummary";
import {Credit} from "../../classes/rest-classes/Credit";
import {UserValidateResponse} from "../../classes/UserValidateResponse";

@Injectable({
    providedIn: 'root'
})
export class RestUserService extends BaseRestService {
    private readonly BASE_URL: string;

    constructor(private http: HttpClient) {
        super();
        this.BASE_URL = environment.restApiUrl + '/User';
    }

    public login(accountNumber: number, username: string, password: string): Observable<UserValidateResponse> {
        const url = `${this.BASE_URL}/Validate`;
        let queryParams = new HttpParams();
        queryParams = queryParams.append('AccountNumber', accountNumber);
        queryParams = queryParams.append('Username', username);
        queryParams = queryParams.append('Password', password);
        queryParams = queryParams.append('SourceType', "2");

        return this.http.get<UserValidateResponse>(url, {params: queryParams, headers: this.authHeaders});
    }

    public getFavourites(): Observable<Favourite[]> {
        const url = `${this.BASE_URL}/Favourite`;
        return this.http.get<Favourite[]>(url, {headers: this.authHeaders});
    }

    public addFavourite(productId: number): Observable<any> {
        const url = `${this.BASE_URL}/Favourite`;
        const favourite = new Favourite();
        favourite.websiteProductId = productId;
        return this.http.post(url, favourite, {headers: this.authHeaders});
    }

    public removeFavourite(productId: number): Observable<boolean> {
        const url = `${this.BASE_URL}/Favourite`;
        const favourite = new Favourite();
        favourite.websiteProductId = productId;
        return this.http.delete<boolean>(url, {
            headers: this.authHeaders,
            body: favourite,
        });
    }

    getActiveUsers(): Observable<Dictionary[]> {
        const url = `${this.BASE_URL}/GetActiveUsers`;
        return this.http.get<Dictionary[]>(url, {headers: this.authHeaders});
    }

    public getProductSummaryBasedOnUser(userId: number): Observable<ProductSummary> {
        const url = `${this.BASE_URL}/${userId}/ProductSummary`;
        return this.http.get<ProductSummary>(url, {headers: this.authHeaders});
    }

    public getUserCredit(): Observable<Credit[]> {
        const url = `${this.BASE_URL}/Credit`;
        return this.http.get<Credit[]>(url, {headers: this.authHeaders});
    }

    ExtendToken(restApiToken: string): Observable<boolean> {
        const url = `${this.BASE_URL}/Extend`;
        let queryParams = new HttpParams().set('userToken', restApiToken);
        return this.http.get <boolean>(url, {params: queryParams, headers: this.authHeaders});
    }
}